module.exports = __webpack_public_path__ + "static/media/birdplay.6fb66dac.png";